import React from 'react'
import './styles.scss'
import NumberFormat from 'react-number-format'

export class CandidatesRows extends React.Component {
  render() {
    const PARTIES = {
      Pda: 'POP',
      SP: 'PS',
      EDU: 'UDF',
      CVP: 'PDC',
      EVP: 'PEV',
      BDP: 'PBD',
      GLP: "Vert'libéraux",
      Grüne: 'Verts',
      SVP: 'UDC',
      CSP: 'PCS',
      MCR: '',
      FDP: 'PLR',
      Liberale: '',
      Lega: '',
      HPS: '',
      PNOS: '',
      PPS: 'Parti Pirate',
      CSPO: '',
      TPS: '',
      ECOPOP: '',
      LdU: '',
      GEM: '',
      IP: '',
      VB: '',
      EAG: '',
      RCV: '',
      KJ: '',
      PC: '',
      'Autopartei FPS': '',
      SD: ''
    }

    const candidates = this.props.limit
      ? this.props.candidates.slice(0, this.props.limit)
      : this.props.candidates

    return (
      <div className='candidates'>
        {candidates.map((candidate, i) => {
          const party = PARTIES[candidate.party] || candidate.party
          let votes = null
          if (
            candidate.elected &&
            candidate['attends round 1'] &&
            this.props.round === 2
          ) {
            votes =
              'Élu' + (candidate.sex === 'f' ? 'e' : '') + ' au premier tour'
          } else if (candidate['votes round ' + this.props.round]) {
            votes = (
              <NumberFormat
                value={+candidate['votes round ' + this.props.round]}
                displayType='text'
                thousandSeparator="'"
              />
            )
          } else {
            votes = (
              <svg
                style={{
                  margin: 'auto',
                  background: '#fff',
                  display: 'inline-block'
                }}
                width='18px'
                height='18px'
                viewBox='0 0 100 100'
                preserveAspectRatio='xMidYMid'
              >
                <path
                  fill='none'
                  d='M50 32.5A17.5 17.5 0 0 1 50 67.5A17.5 17.5 0 0 1 50 32.5'
                  stroke='#d8d8d8'
                  strokeWidth='35'
                >
                  <animate
                    attributeName='stroke-dasharray'
                    repeatCount='indefinite'
                    dur='5'
                    values='0 0 0 110;0 0 110 110;0 110 110 110'
                    keyTimes='0;0.5;1'
                    keySplines='0.5 0 0.5 1;0.5 0 0.5 1'
                    calcMode='spline'
                  />
                  <animate
                    attributeName='stroke'
                    values='#d8d8d8;#d8d8d8;#d8d8d8;#d8d8d8;#d8d8d8'
                    keyTimes='0;0.25;0.5;0.75;1'
                    dur='20s'
                    calcMode='discrete'
                    repeatCount='indefinite'
                  />
                </path>
              </svg>
            )
          }

          return (
            <div className='candidate' key={'candidate-' + i}>
              <div
                className={'picture'}
                style={{
                  backgroundColor: candidate.color,
                  backgroundImage:
                    'url(' +
                    (candidate['picture url'] ||
                      require('../../images/portrait.svg')) +
                    ')'
                }}
              />
              <div className='result'>
                <div className='name'>
                  {candidate['first name']} {candidate['last name']}{' '}
                  {candidate.outgoing
                    ? '(sortant' + (candidate.sex === 'f' ? 'e' : '') + ')'
                    : ''}
                </div>
                <div
                  className={
                    'bar-wrapper' +
                    (candidate['votes round ' + this.props.round]
                      ? ''
                      : ' no-data')
                  }
                >
                  <div className='party'>{party}</div>
                  <div className='bar-container'>
                    {this.props.absMajority > 0 && (
                      <div
                        className='clear-majority'
                        style={{
                          left:
                            (this.props.absMajority / this.props.validVotes) *
                              100 +
                            '%'
                        }}
                      />
                    )}
                    <div
                      className={'bar-active'}
                      style={{
                        backgroundColor: candidate.color,
                        width:
                          (candidate['votes round ' + this.props.round] /
                            this.props.validVotes) *
                            100 +
                          '%'
                      }}
                    />
                    <div
                      className={'bar-background party-' + candidate.party}
                    />
                  </div>
                  <div className='votes'>{votes}</div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default CandidatesRows
